import {Transform} from 'stream'
import PropertyStream from 'pw-property-stream'

// a stream that maintains a list of available investigations

class InvestigationListTransform extends Transform {
  constructor () {
    super({objectMode: true, highWaterMark: 0})
    this.investigationMap = new Map()
  }

  _transform (data, enc, next) {
    data.forEach((investigationInfo) => {
      investigationInfo.createdAt = new Date(investigationInfo.createdAt)
      if (investigationInfo.lastViewed) {
        investigationInfo.lastViewed = new Date(investigationInfo.lastViewed)
      }
      this.investigationMap.set(investigationInfo.id, investigationInfo)
    })
    next(null, [...this.investigationMap.values()])
  }
}

export default class InvestigationListStream {
  constructor (events) {
    this.output = PropertyStream()
    events.on('authenticated', this.onAuth.bind(this))
    events.on('unauthenticated', this.onUnauth.bind(this))
    events.once('init', this.init.bind(this))
  }

  init (namePrefix, streamingClient) {
    this.namePrefix = namePrefix
    this.streamingClient = streamingClient
  }

  onAuth () {
    this.investigationListStream0 = this.streamingClient.create({
      name: `${this.namePrefix}immersive-investigation-lists`,
      path: 'immersive/investigation-list'
    })

    this.investigationListStream0
      .pipe(new InvestigationListTransform())
      .pipe(this.output, {end: false})
  }

  onUnauth () {
    this.investigationListStream0.destroy()
    this.investigationListStream0 = null
  }
}
